import { makeStyles, tokens } from '@fluentui/react-components';

export const useCartSectionStyles = makeStyles({
    header: {
        marginTop: '0',
        marginBottom: tokens.spacingVerticalXXL
    },
    lineSection: {
        marginBottom: tokens.spacingVerticalXXXL
    }
});
